import React, { useState } from 'react';
import CountUp from 'react-countup';
import VisibilitySensor from 'react-visibility-sensor';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import LanguageIcon from '@mui/icons-material/Language';
import InstagramIcon from '@mui/icons-material/Instagram';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import TvIcon from '@mui/icons-material/Tv';

const MetricsSection = () => {
  const theme = useTheme();

  const [viewPortEntered, setViewPortEntered] = useState(false);
  const setViewPortVisibility = (isVisible) => {
    if (viewPortEntered) return;
    setViewPortEntered(isVisible);
  };

  const iconProps = { sx: { fontSize: 40, color: theme.palette.primary.main } };

  const metricsData = [
    {
      title: 90,
      label: 'Seguidores (todas las redes)',
      subtitle: 'Comunidad total sumada del ecosistema TNO Network.',
      suffix: 'K+',
      icon: <InstagramIcon {...iconProps} />,
    },
    {
      title: 30,
      label: 'Miles de visitas mensuales',
      subtitle: 'Tráfico en el ecosistema TNO (web, shows y Digest).',
      suffix: 'K+',
      icon: <LanguageIcon {...iconProps} />,
    },
    {
      title: 300,
      label: 'Impresiones en Instagram (marzo)',
      subtitle: 'Alcance orgánico y amplificado del contenido en Instagram.',
      suffix: 'K+',
      icon: <PlayCircleOutlineIcon {...iconProps} />,
    },
    {
      title: 24,
      label: 'Streaming activo',
      subtitle: 'Presencia continua para impulsar recordación y performance.',
      suffix: '/7',
      icon: <TvIcon {...iconProps} />,
    },
  ];

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
          gutterBottom
          color="primary"
          align="center"
        >
          Métricas
        </Typography>
        <Box
          component={Typography}
          fontWeight={700}
          variant="h4"
          gutterBottom
          align="center"
          color="primary"
        >
          El alcance de TNO para Daka
        </Box>
        <Typography
          variant="body1"
          align="center"
          color="textSecondary"
          sx={{ mb: 4, maxWidth: 720, mx: 'auto' }}
        >
          Daka complementa su presencia de marca con un ecosistema digital medible: streaming, contenido editorial
          (SEO) y activaciones UGC que sostienen la conversación y mueven intención de compra.
        </Typography>
      </Box>
      <Grid container spacing={3}>
        {metricsData.map((item, i) => (
          <Grid key={i} item xs={12} sm={6} md={3}>
            <Box display="flex" justifyContent="center" alignItems="center" marginBottom={2}>
              {item.icon}
            </Box>
            <Typography variant="h4" align="center" gutterBottom>
              <Box component="span" fontWeight={700}>
                <VisibilitySensor onChange={(isVisible) => setViewPortVisibility(isVisible)} delayedCall>
                  <CountUp
                    redraw={false}
                    end={viewPortEntered ? item.title : 0}
                    start={0}
                    suffix={item.suffix}
                  />
                </VisibilitySensor>
              </Box>
            </Typography>
            <Typography align="center" variant="subtitle1" fontWeight={600} gutterBottom>
              {item.label}
            </Typography>
            <Typography color="textSecondary" align="center" variant="body2" component="p">
              {item.subtitle}
            </Typography>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default MetricsSection;

